import React from 'react';
import moment from 'moment';
import {formatFileSize} from 'utils/common';
import useClickPreventionOnDoubleClick from 'hooks/useDoubleClick';
import {getFileIcon} from 'utils/commonReact';
import {ReactComponent as LinkIcon} from 'assets/svgs/actions/link.svg';

const Row = ({post, selected, setSelected, onEnter}) => {
  const onClick = () => {
    if (post.isSpecial) return;
    setSelected(post);
  };

  const onDoubleClick = () => {
    if (post.isDeleted) return;

    onEnter(post);
  };

  const [handleClick, handleDoubleClick] = useClickPreventionOnDoubleClick(
    onClick,
    onDoubleClick
  );
  const getQuantity = () => (
    <span className="w-auto px-3">{post.files ? post.files.length : 0}</span>
  );

  const calculateVolume = (files) => {
    const total = files.reduce((count, file) => {
      if (file.size) {
        count += file.size;
      }
      return count;
    }, 0);

    return formatFileSize(total, 2);
  };

  const getUrl = () => `${post.liveURL}`;

  return (
    <React.Fragment key={post.uniqueId}>
      <tr
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        className={`pointer border-bottom ${
          post.folderType ? post.folderType.toLowerCase() : 'file'
        } ${post.pageFolderId ? 'bg-white' : 'bg-gray4'} ${
          selected.find((f) => f.uniqueId === post.uniqueId)
            ? 'color-white bg-eclipse'
            : ''
        }`}
      >
        <td className="p-0"></td>
        <td className="py-0">
          <div data-tip className="py-3 d-flex align-items-center">
            {getFileIcon(
              post,
              post.folderType === 'FILE' || post.logoType ? getUrl() : null
            )}
            <p className="post-names mb-0 ml-2"> {post.name}</p>
          </div>
        </td>
        <td className="py-3 text-center">
          {!post.folderType || post.folderType === 'FILE' ? (
            <div className="d-flex w-100 justify-content-center">
              <a
                onClick={(e) => e.stopPropagation()}
                href={getUrl()}
                className="d-flex align-items-center justify-content-center lang-uages"
                target="_blank"
              >
                <LinkIcon />
              </a>
            </div>
          ) : (
            <span className="user-text-color">
              {post.uniqueId.substring(0, 12)}
            </span>
          )}
        </td>
        <td className="py-3 text-center post-key post-length">
          {getQuantity()}
        </td>
        <td className="py-3 text-center">
          <span className="user-text-color">
            {moment(post.updatedAt).format('YYYY-MM-DD')}
          </span>
        </td>
        <td className="py-3 text-center">
          <span className="user-text-color">
            {!post.folderType || post.folderType === 'FILE'
              ? formatFileSize(post.size, 2)
              : calculateVolume(
                  post.nestedFiles && post.nestedFiles.length > 0
                    ? post.nestedFiles
                    : post.files
                )}
          </span>
        </td>

        <td className="p-0"></td>
      </tr>
    </React.Fragment>
  );
};

export default Row;
